export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_14-EN-ede566fa5cdf9d8702970ab6a8b90a40.webp";